import React, { useRef, useEffect, useState } from "react";
import "./Responsible.scss";
import useAuthStore from "../../../../store/authStore";
import { fetchProjectById } from "../../../../api/projects";
import UserAvatar from "../../../../components/UserAvatar/UserAvatar";

function Responsible({ updateResponsible, selectedResponsible }) {
  const { user, currentProject } = useAuthStore();
  const inputRef = useRef(null);
  const [filter, setFilter] = useState("");
  const [projectMembers, setProjectMembers] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      inputRef.current?.focus();
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  // Fetch current project members
  useEffect(() => {
    const fetchMembers = async () => {
      if (currentProject?._id && user?.id) {
        try {
          const project = await fetchProjectById(currentProject._id, user.id);
          // Transform members to match expected format
          const members = (project?.members || [])
            .filter((m) => m.userId) // Filter out null/deleted users
            .map((m) => ({
              userId: m.userId,
              firstName: m.firstName,
              lastName: m.lastName,
              email: m.email,
              role: m.role,
              profile: m.profile,
            }));
          setProjectMembers(members);
          //   "Updated project members state:",
          //   members.length,
          //   "members"
          // );
        } catch (error) {
          console.error("Error fetching project members:", error);
          setProjectMembers([]);
        }
      }
    };

    fetchMembers();

    // Listen for project member updates to refresh the list
    const handleMembersUpdated = () => {
      //   "Project members updated event received, refreshing responsible list..."
      // );
      fetchMembers();
    };

    window.addEventListener("projectMembersUpdated", handleMembersUpdated);

    return () => {
      window.removeEventListener("projectMembersUpdated", handleMembersUpdated);
    };
  }, [currentProject, user]);

  const filteredMembers = projectMembers
    .filter((member) => {
      const first = member?.firstName?.toLowerCase() || "";
      const last = member?.lastName?.toLowerCase() || "";
      const full = `${first} ${last}`;
      return (
        first.includes(filter.toLowerCase()) ||
        last.includes(filter.toLowerCase()) ||
        full.includes(filter.toLowerCase())
      );
    })
    .sort((a, b) => {
      // Sort by role first (admin before member)
      if (a.role === "admin" && b.role !== "admin") return -1;
      if (a.role !== "admin" && b.role === "admin") return 1;

      // If same role, sort alphabetically by first name
      const nameA = `${a.firstName} ${a.lastName}`.toLowerCase();
      const nameB = `${b.firstName} ${b.lastName}`.toLowerCase();
      return nameA.localeCompare(nameB);
    });

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && filteredMembers.length === 1) {
      updateResponsible(filteredMembers[0]);
    }
  };

  return (
    <div className="responsible-content">
      <div className="modal-title">
        <div>Select Responsible</div>
      </div>
      <div className="modal-body">
        <input
          type="text"
          className="modal-text-input"
          ref={inputRef}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Search members..."
        />
        <div className="members-list">
          {filteredMembers.map((member, index) => (
            <div
              key={index}
              className={`member-item ${
                selectedResponsible?.userId === member?.userId ? "selected" : ""
              }`}
              onClick={() => updateResponsible(member)}
              style={{ cursor: "pointer" }}
            >
              <UserAvatar user={member} size="medium" />
              <div className="member-name">
                {member.firstName} {member.lastName}
                {member.role === "admin" && (
                  <span className="admin-badge"> Admin</span>
                )}
              </div>
            </div>
          ))}
        </div>
        <hr className="separator" />
        <div className="clear-button" onClick={() => updateResponsible(null)}>
          Clear
        </div>
      </div>
    </div>
  );
}

export default Responsible;
